import { GeneratedTemplateType } from "../../../types/util-types";

const VerticalFeatureBlockStore = {
    [GeneratedTemplateType.CONTRACT]: {
        title: 'verticalFeaturesBlock.title',
        subtitle: 'verticalFeaturesBlock.subtitle',
        gridItems: [
            {
            transId: 'verticalFeaturesBlock.featureGrid.businessManagement',
            imagePath: 'marketing_site/ai_templates/Subtract.png',
            mediaFlags: {
                width: 32,
                height: 32
            },
        },
        {
            transId: 'verticalFeaturesBlock.featureGrid.automations',
            imagePath: 'marketing_site/ai_templates/Frame_1000001596.png',
            mediaFlags: {
                width: 36,
                height: 36
            },
        },
        {
            transId: 'verticalFeaturesBlock.featureGrid.finances',
            imagePath: 'marketing_site/ai_templates/Group_1000002254.png',
            mediaFlags: {
                width: 60,
                height: 40
            },
            },
        {
            transId: 'verticalFeaturesBlock.featureGrid.collaboration',
            imagePath: 'marketing_site/ai_templates/Frame_1073713849.png',
            mediaFlags: {
                width: 40,
                height: 40
            },
        },
        {
            transId: 'verticalFeaturesBlock.featureGrid.onlinePayments',
            imagePath: 'marketing_site/ai_templates/Frame_48096198.png',
            mediaFlags: {
                width: 40,
                height: 40
            },
        },
        {
            transId: 'verticalFeaturesBlock.featureGrid.scheduling',
            imagePath: 'marketing_site/ai_templates/Group_48096347.png',
            mediaFlags: {
                width: 40,
                height: 40
                },
            }
        ]
    }
};

export default VerticalFeatureBlockStore;
